import {GameLogicInterface} from 'poker-interfaces';

export enum PLAYER_ACTION {
  BET = 'BET',
  CHECK = 'CHECK',
  CALL = 'CALL',
  RAISE = 'RAISE',
  FOLD = 'FOLD',
  CANCEL_INSURANCE = 'INSURANCE_CANCEL',
  CONFIRM_INSURANCE = 'INSURANCE_BUY',
  ALL_IN = 'ALL_IN',
}

export enum PLAYER_ROLE {
  BUTTON = 'BUTTON',
  BIG_BLIND = 'BIG_BLIND',
  SMALL_BLIND = 'SMALL_BLIND',
}

export enum RESULT_TYPE {
  WIN = 'WIN',
  DRAW = 'DRAW',
  ALL_FOLDED = 'ALL_FOLDED',
}

export enum SUIT {
  SPADE = 'SPADE',
  HEART = 'HEART',
  CLUB = 'CLUB',
  DIAMOND = 'DIAMOND',
}

export const ACTIONS = {
  SET_CAPITAL: 'game/player/set-base',
  SET_PLAYER_ACTION: 'game/set-player-action',
};

export const GAME_EVENTS = {
  ROOM_INIT: 'game/broadcast-room-initiating',
  GAME_INIT: 'game/broadcast-game-init',
  YOUR_TURN: 'game/broadcast-your-turn',
  PLAYER_IN_ACTION: 'game/broadcast-player-in-action',
  PLAYER_DECISION: 'game/broadcast-player-decision',

  TABLE_UPDATE: 'game/broadcast-table',

  GAME_RESULT: 'game/broadcast-game-result',

  GET_ROOM_INFO: 'game/request_room_info',
  EXIT_ROOM: 'game/exit-room',
  GAME_RESTART: 'game/broadcast-game-restart',
  SET_BASE: 'game/broadcast-set-base',
};

export const getGameEventV2 = (roomNumber: string = '') => {
  return {
    REQUEST_ROOM_ACCESS: roomNumber.concat('/access'),
    JOIN_ROOM: roomNumber,

    DIRECT_GAME_INVITE: roomNumber.concat('/direct/game-invite'),
    DIRECT_SET_BASE: roomNumber.concat('/direct/set-base'),

    BROADCAST_GENERAL: roomNumber.concat('/broadcast/general'),
    BROADCAST_GAME_INIT: roomNumber.concat('/broadcast/game-init'),
    BROADCAST_PLAYER_IN_ACTION: roomNumber.concat('/broadcast/player-in-action'),
    BROADCAST_INSURANCE: roomNumber.concat('/broadcast/insurance'),
    BROADCAST_FOLD_ANNOUNCE: roomNumber.concat('/broadcast/fold-announce'),
    BROADCAST_DECISION_ANNOUNCE: roomNumber.concat('/broadcast/decision-announce'),
    BROADCAST_TABLE: roomNumber.concat('/broadcast/table'),
    BROADCAST_GAME_RESULT: roomNumber.concat('/broadcast/game-result'),
    BROADCAST_GAME_RESTART: roomNumber.concat('/broadcast/game/broadcast-game-restart'),
    BROADCAST_STICKER_SUCCESS: roomNumber.concat('/broadcast/sticker-success'),

    EM_PLAYER_SET_BASE: roomNumber.concat('/em/player/set-base'),
    EM_SERVER_PRIVATE_INFO: roomNumber.concat('/em/server/private-info'),
    EM_SERVER_YOUR_TURN: roomNumber.concat('/em/server/your-turn'),
    EM_SERVER_BUY_INSURANCE: roomNumber.concat('/em/server/buy-insurance'),
    EM_PLAYER_SET_ACTION: roomNumber.concat('/em/player/set-action'),
    EM_PLAYER_SEND_STICKER: roomNumber.concat('/em/player/send-sticker'),
  };
};

export const getLobbyEvent = () => {
  return {
    ONLINE_PLAYER_COUNTS: 'lobby:online-player-counts',
    REAL_TIME_PLAYER_STATISTICS: 'lobby:real-time-player-stats',
    REAL_TIME_ROOM_STATISTICS: 'lobby:real-time-room-stats',
    REAL_TIME_PLAYER_RANKING: 'lobby:real-time-player-ranking',
    SUBSCRIBE_GAME_STATE: 'lobby:SUBSCRIBE_GAME_STATE',
    EM_FETCH_LATEST_PLAYER_STAT: 'lobby:FETCH_LATEST_PLAYER_STAT',
  };
};

export const getGameEventV3 = () => {
  return {
    REQUEST_ROOM_ACCESS: 'room-access',
    JOIN_ROOM: 'join-room',

    DIRECT_GAME_INVITE: 'em/server/game-invite',
    DIRECT_SET_BASE: 'em/server/set-base',

    BROADCAST_GENERAL: 'broadcast/general',
    BROADCAST_GAME_INIT: 'broadcast/game-init',
    BROADCAST_PLAYER_IN_ACTION: 'broadcast/player-in-action',
    BROADCAST_INSURANCE: 'broadcast/insurance',
    BROADCAST_FOLD_ANNOUNCE: 'broadcast/fold-announce',
    BROADCAST_DECISION_ANNOUNCE: 'broadcast/decision-announce',
    BROADCAST_TABLE: 'broadcast/table',
    BROADCAST_GAME_RESULT: 'broadcast/game-result',
    BROADCAST_GAME_RESTART: 'broadcast/game/broadcast-game-restart',
    BROADCAST_STICKER_SUCCESS: 'broadcast/sticker-success',
    BROADCAST_NOTIFICATIONS_PRIVATE_ROOM_TIME_EXPIRED:
      'broadcast/notifications/private-room-time-expired',
    BROADCAST_NOTIFICATIONS_PRIVATE_ROOM_TIME_REMAINING:
      'broadcast/notifications/private-room-time-remaining',

    EM_PLAYER_SET_BASE: 'player/set-base',
    EM_SERVER_PRIVATE_INFO: 'em/server/private-info',
    EM_SERVER_YOUR_TURN: 'em/server/your-turn',
    EM_SERVER_BUY_INSURANCE: 'em/server/buy-insurance',
    EM_PLAYER_SET_ACTION: 'player/set-action',
    EM_SERVER_NOTIFICATIONS_NOTIFY_AFK_LEAVE_TABLE:
      'em/server/notifications/notify-afk-leave-table',
    EM_SERVER_NOTIFICATIONS_NOTIFY_FORCE_EXIT_ROOM:
      'em/server/notifications/notify-force-exit-room',
    EM_SERVER_NOTIFICATIONS_NOTIFY_NO_ENOUGH_MONEY_TO_BUY_IN:
      'em/server/notifications/notify-no-enough-money-to-buy-in',
    EM_SERVER_NOTIFICATIONS_NOTIFY_SET_BUY_IN_EXPIRED:
      'em/server/notifications/notify-set-buy-in-expired',
    EM_SERVER_NOTIFICATIONS_NOTIFY_SIT_OUT: 'em/server/notifications/notify-sit-out',
    EM_SERVER_NOTIFICATIONS_NOTIFY_SIT_OUT_KICK: 'em/server/notifications/notify-sit-out-kick',
    EM_SERVER_NOTIFICATIONS_NOTIFY_WALLET_TOP_UP_REQUIRED:
      'em/server/notifications/notify-wallet-top-up-required',
    EM_PLAYER_SET_TABLE_ACTION: 'player/set-table-action',
    EM_PLAYER_SET_ROOM_ACTION: 'player/set-room-action',

    EM_PLAYER_SEND_STICKER: 'player/send-sticker',
    EM_PLAYER_SET_WITHDRAW_EXTRA_BET: 'player/set-withdraw-bet',
    EM_PLAYER_ADD_EXTRA_BET: 'player/add-extra-bet',

    GAME_ROOM_CONNECTED: 'GAME_ROOM_CONNECTED',
    DUPLICATE_LOGIN: 'DUPLICATE_LOGIN',
    DUPLICATE_IP: 'DUPLICATE_IP',
    DUPLICATE_DEVICE: 'DUPLICATE_DEVICE',
    DEVICE_LOGIN_RESTRICTION: 'DEVICE_LOGIN_RESTRICTION',
    LOGIN_TOKEN_INVALID: 'LOGIN_TOKEN_INVALID',
    EM_SERVER_NOTIFICATIONS_NOTIFY_RESTRICTION_IP_DEVICE_SAME_ROOM:
      'EM_SERVER_NOTIFICATIONS_NOTIFY_RESTRICTION_IP_DEVICE_SAME_ROOM',
    EM_SERVER_NOTIFICATIONS_NOTIFY_SERVER_MAINTENANCE:
      'EM_SERVER_NOTIFICATIONS_NOTIFY_SERVER_MAINTENANCE',
    EM_PLAYER_SET_RESTART_GAME: 'player/set-restart-game',
    EM_PLAYER_SET_ACTION_RESULT: 'em/player/set-action',

    SET_BUY_IN_RESULT: 'game/set-buy-in-result',
    SET_AUTO_ACTION_RESULT: 'game/set-auto-action-result',
    SWITCH_TO_OBSERVER_RESULT: 'game/switch-to-observer-result',
    ADD_EXTRA_BET_RESULT: 'game/add-extra-bet-result',
    WITHDRAW_EXTRA_BET_RESULT: 'game/withdraw-extra-bet-result',
    EXIT_TABLE_RESULT: 'game/exit-table-result',
    CONFIRM_INSURANCE_RESULT: 'game/confirm-insurance-result',
    CANCEL_INSURANCE_RESULT: 'game/cancel-insurance-result',
    SEND_STICKER_RESULT: 'game/send-sticker-result',
    WAIT_FOR_BLINDS_RESULT: 'game/wait-for-blinds-result',
    JOIN_ROOM_RESULT: 'game/join-room-result',
    SET_ACTION_RESULT: 'game/set-action-result',
    SIT_IN_RESULT: 'game/sit-in-result',
    SIT_OUT_RESULT: 'game/sit-out-result',

    GAME_ROOM: {
      INVITE_TO_TOURNAMENT: 'game:invite-to-tournament',
      TOURNAMENT_PLAYER_RANKING: 'game:tournament-player-ranking',
      TOURNAMENT_RESULT_ANNOUNCEMENT: 'game:tournament-ranking-announce',
      TOURNAMENT_REBUY_INVITE: 'game:tournament-rebuy-invite',
      TOURNAMENT_THANKS_FOR_JOINING: 'game:tournament-thanks-for-joining',
      TOURNAMENT_CANCELLED: 'game:tournament-cancelled',
      TOURNAMENT_WAITING_FOR_PLAYERS: 'game:tournament-waiting-for-players',
      TOURNAMENT_WAITING_STATUS_UPDATE: 'game:tournament-waiting-status-update',
    },
    TOURNAMENT: {
      TOURNAMENT_EARLY_JOIN: 'tournament:join',
      TOURNAMENT_RE_ENTRY: 'tournament:re-entry',
      TOURNAMENT_STACK: 'TOURNAMENT:STACK',
      TOURNAMENT_JOIN_RESULT: 'TOURNAMENT_JOIN_RESULT',
      TOURNAMENT_RE_ENTRY_RESULT: 'TOURNAMENT_RE_ENTRY_RESULT',
    },

    WALLET_EVENT_NOTIFICATION: 'NOTIFICATION',
  };
};

export const TABLE_ACTIONS = {
  JOIN_TABLE: 'JOIN_TABLE',
  EXIT_TABLE: 'EXIT_TABLE',
  SWITCH_TO_OBSERVER: 'SWITCH_TO_OBSERVER',
  SIT_OUT: 'SIT_OUT',
  SIT_IN: 'SIT_IN',
  WAIT_FOR_BLINDS_FALSE: 'WAIT_FOR_BLINDS_FALSE',
  WAIT_FOR_BLINDS_TRUE: 'WAIT_FOR_BLINDS_TRUE',
};

export enum ROOM_ACTION {
  EXIT_ROOM = 'EXIT_ROOM',
  DISCONNECT = 'DISCONNECT',
  PRIVATE_ROOM_ADD_FUND = 'PRIVATE_ROOM_ADD_FUND',
}

export enum PLAYER_NOTIFICATION_TYPE {
  PLAYER_NOTIFICATION_TYPE_TOURNAMENT_CANCELLED = 'tournament_cancelled',
  PLAYER_NOTIFICATION_TYPE_TOURNAMENT_ENTRY_FEE_REFUND = 'tournament_entry_fee_refund',
  PLAYER_NOTIFICATION_TYPE_TOURNAMENT_END = 'tournament_end',
}
// TODO @@ chips
// export const CHIP_TRANSITION_DURATION = 600;
export const CHIP_TRANSITION_DURATION = 500;
export const CHIP_MOVING_DURATION = CHIP_TRANSITION_DURATION / 2;
export const CHIP_FADING_DURATION = CHIP_TRANSITION_DURATION / 2;

export const EMOJI_TRANSITION_DURATION = 1000;

export const TABLE_UPDATE_DELAY = 350;
export const COLLECT_CHIP_DELAY = 300;

export enum PLAYER_LAYOUT {
  PLAYER_LEFT_ACTION_RIGHT,
  PLAYER_LEFT_ACTION_RIGHT_TOP,
  PLAYER_RIGHT_ACTION_LEFT,
  PLAYER_BOTTOM_ACTION_TOP,
  PLAYER_TOP_ACTION_BOTTOM,
  ALL_IN_TOP_LEFT,
  ALL_IN_TOP_RIGHT,
  ALL_IN_TOP_ACTION_BOTTOM,
  ALL_IN_BOTTOM_ACTION_TOP,
}

export const GAME_MODE = {
  REGULAR: 'REGULAR',
  // ALL_IN: 'ALL_IN',
  SHORT: 'SHORT',
  OMAHA: 'OMAHA',
};

export const COLOR_THEME = {
  PURPLE: 'PURPLE',
  GOLDEN: 'GOLDEN',
  GREEN: 'GREEN',
};

export const HAND_TYPE = {
  HI_CARD: 'HI_CARD',
  PAIR: 'PAIR',
  TWO_PAIRS: 'TWO_PAIRS',
  THREE_OF_A_KIND: 'THREE_OF_A_KIND',
  FOUR_OF_A_KIND: 'FOUR_OF_A_KIND',
  STRAIGHT: 'STRAIGHT',
  FLUSH: 'FLUSH',
  STRAIGHT_FLUSH: 'STRAIGHT_FLUSH',
  FULL_HOUSE: 'FULL_HOUSE',
  ROYAL_FLUSH: 'ROYAL_FLUSH',
};

export const UNIT_TYPE = {
  BIG_BLIND: 'BIG_BLIND',
  USD: 'USD',
};

export const GAME_TABLE_MARGIN_PX = 70;

export const TIME_DIFFERENCE_THRESHOLD = 1000;

export const TIME_DIFFERENCE_CHECK_COUNT = 3;

export type ButtonLoadingState = {
  action: GameLogicInterface.Action;
  value?: number;
  // * below props are for shortcut buttons
  unit?: 'POT' | 'BB' | 'MAX' | 'POT_PERCENT';
  unitValue?: number;
} | null;

export const TRANSITION_DURATION = 200;
export const COMMUNITY_CARD_FLIP_DELAY = 0;
export const COMMUNITY_CARD_PRE_FLOP_FLIP_DELAY =
  TRANSITION_DURATION * 4 + COMMUNITY_CARD_FLIP_DELAY;
export const COMMUNITY_CARD_POST_FLOP_FLIP_DELAY =
  TRANSITION_DURATION * 2 + COMMUNITY_CARD_FLIP_DELAY;
